export default __webpack_public_path__ + "static/media/Instagram - Negative.20665adf.svg";